import AuthContext from "./AuthContext";
import { useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { privateAxios } from "./utils/axios";

function ProtectedWrapper(props) {
  const auth = useContext(AuthContext);
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const initializeAuth = async () => {
      const token = localStorage.getItem("token");

      if (token) {
        try {
          const response = await privateAxios.get("/auth/me");
          console.log(response.data);
          if (response.data.success) {
            // Store complete user data including permissions
            localStorage.setItem("user", JSON.stringify(response.data.data));

            auth.signin(response.data.data._id, () => {
              setIsLoading(false);
            });
          } else {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            setIsLoading(false);
          }
        } catch (error) {
          console.error("Auth check failed:", error);
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    initializeAuth();
  }, []); // Empty dependency array to run only once on mount

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <h1>Loading...</h1>
      </div>
    );
  }

  if (!auth.user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return props.children;
}

export default ProtectedWrapper;
